// extracted by mini-css-extract-plugin
export default {"button":"PaginationButton_button__p436I","btnDisabled":"PaginationButton_btnDisabled__v0NVQ","ml":"PaginationButton_ml__UuEtH","mr":"PaginationButton_mr__-NfN8"};